/** Small inline icons for the ticket grid (no icon font needed). */
const base = { width: 16, height: 16, viewBox: "0 0 24 24", "aria-hidden": true } as const;

export const MailIcon = () => (
  <svg {...base} fill="currentColor"><path d="M3 5h18a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm9 7.2L4.4 7H4v.6l8 5.6 8-5.6V7h-.4L12 12.2Z" /></svg>
);
export const TextIcon = () => (
  <svg {...base} fill="currentColor"><path d="M4 3h16a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H8l-5 4V5a2 2 0 0 1 1-2Zm3 6v2h10V9H7Zm0 4v2h7v-2H7Z" /></svg>
);
export const CardIcon = () => (
  <svg {...base} fill="currentColor"><path d="M3 5h18a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm1 3v2h16V8H4Zm2 6v2h5v-2H6Z" /></svg>
);
export const BellOffIcon = () => (
  <svg {...base} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M18 8a6 6 0 0 0-9.3-5M6 8c0 7-3 9-3 9h14M13.7 21a2 2 0 0 1-3.4 0M3 3l18 18" />
  </svg>
);
